// Approved payment routing. Override the complete object at deployment with
// NUXT_PUBLIC_FLYPAY_RETURN_ROUTING (JSON); never infer a bridge for other shops.
export default {
  callbackOrigin: 'https://lynicebuy.shop',
  bridges: [
    {
      id: 'drawlark',
      sourceOrigin: 'https://drawlark.store',
      targetOrigin: 'https://drawlark.store',
    },
    {
      id: 'mistrow',
      sourceOrigin: 'https://mistrow.shop',
      targetOrigin: 'https://mistrow.shop',
    },
  ],
}
